<div class="autocomplete-field" #fieldRef>
  <input #inputRef type="text" class="autocomplete-input medium-text" [ngClass]="{ 'autocomplete-input-open': isOpen }"
    [placeholder]="placeholder" [(ngModel)]="searchTerm" (input)="onInput()"
    (keydown.escape)="cancel()" autocomplete="off" id="autocompleteInput" />
  <button type="button" class="dropdown-toggle" [ngClass]="{ 'dropdown-toggle-offset': iconOffset, 'dropdown-toggle-open': isOpen }"
    (mousedown)="$event.preventDefault()" (click)="toggle()" id="btnAutocompleteToggle" aria-label="Toggle options">
    <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 512.02 319.26">
      <path fill="currentColor"
        d="M5.9 48.96 48.97 5.89c7.86-7.86 20.73-7.84 28.56 0l178.48 178.48L434.5 5.89c7.86-7.86 20.74-7.82 28.56 0l43.07 43.07c7.83 7.84 7.83 20.72 0 28.56l-192.41 192.4-.36.37-43.07 43.07c-7.83 7.82-20.7 7.86-28.56 0l-43.07-43.07-.36-.37L5.9 77.52c-7.87-7.86-7.87-20.7 0-28.56z" />
    </svg>
  </button>

  @if (isOpen) {
  <div class="suggestion-panel" [ngClass]="{ 'suggestion-panel-top': placement === 'top', 'suggestion-panel-bottom': placement === 'bottom' }"
    [ngStyle]="panelStyle" (mousedown)="$event.preventDefault()">
    @if (title) {
    <div class="suggestion-header medium-text-bold">{{ title }}</div>
    }
    <div class="suggestion-list">
      @if (showCreateOption) {
      <div class="suggestion-item" (click)="createAndSelectValue()">
        <span class="suggestion-label medium-text">{{ searchTerm.trim() }}</span>
        <span class="suggestion-hint small-text">{{ createHint }}</span>
      </div>
      }
      @for (item of filteredValues; track item) {
      <div class="suggestion-item" (click)="selectItem(item)" [ngClass]="{ 'selected-value': item[valueKey] == selectedValue }">
        <span class="suggestion-label medium-text">{{ item[labelKey] }}</span>
        <span class="suggestion-hint small-text">{{ selectHint }}</span>
      </div>
      }
      @if (!showCreateOption && !filteredValues.length) {
      <div class="suggestion-empty medium-text">No matches found</div>
      }
    </div>
  </div>
  }
</div>
